import React, { Component } from "react";
import { Flex } from "grid-styled";

import AnimationController from "../../components/AnimationController";

import { sortBooks } from "../../utils/sortBooks";

const data = {
    books: [
        {
            id: "1",
            title: "The Design of Everyday Things",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/Design-Everyday-Things-Donald-Norman/dp/1452654123",
            goodreadsLink:
                "https://www.goodreads.com/book/show/840.The_Design_of_Everyday_Things",
            audibleLink:
                "https://www.audible.com/pd/Science-Technology/The-Design-of-Everyday-Things-Audiobook/B005I5MDGQ?ref=a_a_search_c3_lProduct_1_1&pf_rd_p=e81b7c27-6880-467a-b5a7-13cef5d729fe&pf_rd_r=Z150ZF0GTHX4DVZCXWFQ&",
            authors: [
                {
                    id: "1",
                    firstName: "Don",
                    lastName: "Norman",
                    amazonLink:
                        "https://www.amazon.com/Donald-A.-Norman/e/B000APP96A",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "1",
                    reason:
                        "The Design of Everyday Things by Don Norman is one of those design books I end up reading over and over again. I love how it touches on design in relation to cognitive psychology. It’s not about modern product design in the digital sense, but the concepts carry over.",
                    designer: {
                        id: "1",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/mann.jpg",
                        firstName: "Tara",
                        lastName: "Mann",
                        title: "Designer at Basecamp",
                        twitterUsername: "taramann",
                        websiteLink: "http://taramann.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "2",
            title: "The Death and Life of Great American Cities",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/Death-Life-Great-American-Cities/dp/067974195X",
            goodreadsLink:
                "https://www.goodreads.com/book/show/30833.The_Death_and_Life_of_Great_American_Cities",
            audibleLink:
                "https://www.audible.com/pd/History/The-Death-and-Life-of-Great-American-Cities-Audiobook/B005KLTZM8?ref=a_a_search_c3_lProduct_1_1&pf_rd_p=e81b7c27-6880-467a-b5a7-13cef5d729fe&pf_rd_r=F974T4G3VS8JNNY2ZQ74&",
            authors: [
                {
                    id: "6",
                    firstName: "Jane",
                    lastName: "Jacobs",
                    amazonLink:
                        "https://www.amazon.com/Jane-Jacobs/e/B000APEBGY",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "2",
                    reason:
                        "It's an excellent handbook to understand the complex connection between a designer's choices and the outcomes for everyday people. The width of sidewalks affect children's safety and play patterns, the interplay of commerce and residential districts affects the fabric of the community, and so on. If you're passionate about design as a tool to build a better future, start with this book.",
                    designer: {
                        id: "2",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/burka.jpg",
                        firstName: "Daniel",
                        lastName: "Burka",
                        title: "Director of design at Resolve to Save Lives",
                        twitterUsername: "dburka",
                        websiteLink: "",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "3",
            title: "The Intelligent Lifestyle Magazine",
            subtitle: "Smart Editorial Design, Storytelling and Journalism",
            amazonLink:
                "https://www.amazon.com/Intelligent-Lifestyle-Magazine-Storytelling-Journalism/dp/3899556313",
            goodreadsLink:
                "https://www.goodreads.com/book/show/29150480-the-intelligent-lifestyle-magazine",
            audibleLink: "",
            authors: [
                {
                    id: "7",
                    firstName: "Francesco",
                    lastName: "Franchi",
                    amazonLink:
                        "https://www.amazon.com/Francesco-Franchi/e/B00IT5NBOA",
                    __typename: "AuthorType"
                },
                {
                    id: "8",
                    firstName: "Christian",
                    lastName: "Rocca",
                    amazonLink:
                        "https://www.amazon.com/Christian-Rocca/e/B00JDPBG1U",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "3",
                    reason:
                        "Designers should take more inspiration from editorial design rather than digital. Because graphic designers knows their shit, typography has always been a huge part of design. While in digital it's really only been a few years (in comparison) we can plug in whatever fonts we want!",
                    designer: {
                        id: "3",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/johannesson.jpg",
                        firstName: "Jenny",
                        lastName: "Johannesson",
                        title: "Designer at ueno",
                        twitterUsername: "chopse",
                        websiteLink: "http://www.jennyjohannesson.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "4",
            title: "Influence",
            subtitle: "The Psychology of Persuasion",
            amazonLink:
                "https://www.amazon.com/Influence-Psychology-Persuasion-Robert-Cialdini/dp/006124189X",
            goodreadsLink:
                "https://www.goodreads.com/book/show/28815.Influence",
            audibleLink:
                "https://www.audible.com/pd/Business/Influence-Audiobook/B01KWAPBHE",
            authors: [
                {
                    id: "3",
                    firstName: "Robert",
                    lastName: "Cialdini",
                    amazonLink:
                        "https://www.amazon.com/Robert-B.-Cialdini/e/B000AP9KKG/ref=dp_byline_cont_book_1",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "4",
                    reason:
                        "Influence will help you understand how people can be persuaded and hopefully teach you not to manipulate people with Design.",
                    designer: {
                        id: "4",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/hemeon.png",
                        firstName: "Marc",
                        lastName: "Hemeon",
                        title: "Artist and Designer",
                        twitterUsername: "hemeon",
                        websiteLink: "http://hemeon.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "5",
            title: "What Technology Wants",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/What-Technology-Wants-Kevin-Kelly/dp/0143120174",
            goodreadsLink:
                "https://www.goodreads.com/book/show/7954936-what-technology-wants",
            audibleLink:
                "https://www.audible.com/pd/Science-Technology/What-Technology-Wants-Audiobook/B0046VGCLK",
            authors: [
                {
                    id: "9",
                    firstName: "Kevin",
                    lastName: "Kelly",
                    amazonLink:
                        "https://www.amazon.com/Kevin-Kelly/e/B001HCY1LE/ref=dp_byline_cont_book_1",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "5",
                    reason: "It describes our world and its underlying forces.",
                    designer: {
                        id: "5",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/soleio.png",
                        firstName: "Soleio",
                        lastName: "Cuervo",
                        title: "Founder and Partner at Combine",
                        twitterUsername: "soleio",
                        websiteLink: "http://combine.vc/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "6",
            title: "Good Strategy Bad Strategy",
            subtitle: "The Difference and Why It Matters",
            amazonLink: "https://www.amazon.com/dp/B004J4WKEC",
            goodreadsLink:
                "https://www.goodreads.com/book/show/11721966-good-strategy-bad-strategy",
            audibleLink:
                "https://www.audible.com/pd/Business/Good-Strategy-Bad-Strategy-Audiobook/B006W15GVE",
            authors: [
                {
                    id: "2",
                    firstName: "Richard",
                    lastName: "Rumelt",
                    amazonLink:
                        "https://www.amazon.com/Richard-Rumelt/e/B00QMWIEH6/ref=sr_ntt_srch_lnk_1?qid=1521666024&sr=8-1",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "6",
                    reason:
                        "Good Strategy, Bad Strategy teaches you how to assert power over the world.",
                    designer: {
                        id: "5",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/soleio.png",
                        firstName: "Soleio",
                        lastName: "Cuervo",
                        title: "Founder and Partner at Combine",
                        twitterUsername: "soleio",
                        websiteLink: "http://combine.vc/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "7",
            title: "Hooked",
            subtitle: "How to Build Habit-Forming Products",
            amazonLink:
                "https://www.amazon.com/Hooked-How-Build-Habit-Forming-Products-ebook/dp/B00LMGLXTS",
            goodreadsLink:
                "https://www.goodreads.com/book/show/22668729-hooked",
            audibleLink:
                "https://www.audible.com/pd/Business/Hooked-How-to-Build-Habit-Forming-Products-Audiobook/B00HZNTRE0",
            authors: [
                {
                    id: "10",
                    firstName: "Nir",
                    lastName: "Eyal",
                    amazonLink: "https://www.amazon.com/Nir-Eyal/e/B00HJ8021I",
                    __typename: "AuthorType"
                },
                {
                    id: "11",
                    firstName: "Ryan",
                    lastName: "Hoover",
                    amazonLink:
                        "https://www.amazon.com/s/ref=dp_byline_sr_ebooks_2?ie=UTF8&text=Ryan+Hoover&search-alias=digital-text&field-author=Ryan+Hoover&sort=relevancerank",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "7",
                    reason: "It describes how to [persuade] people.",
                    designer: {
                        id: "5",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/soleio.png",
                        firstName: "Soleio",
                        lastName: "Cuervo",
                        title: "Founder and Partner at Combine",
                        twitterUsername: "soleio",
                        websiteLink: "http://combine.vc/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "8",
            title: "Design is Storytelling",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/Design-Storytelling-Ellen-Lupton/dp/194230319X",
            goodreadsLink:
                "https://www.goodreads.com/book/show/34696391-design-is-storytelling",
            audibleLink: "",
            authors: [
                {
                    id: "4",
                    firstName: "Ellen",
                    lastName: "Lupton",
                    amazonLink:
                        "https://www.amazon.com/Ellen-Lupton/e/B001JRZFK8",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "8",
                    reason:
                        "This is a great resource for learning why and how storytelling can be one of the most powerful tools for designers to frame their work.",
                    designer: {
                        id: "6",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/fukui.jpg",
                        firstName: "Kat",
                        lastName: "Fukui",
                        title: "Product designer at GitHub",
                        twitterUsername: "katfukui",
                        websiteLink: "http://katfukui.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "9",
            title: "Technically Wrong",
            subtitle:
                "Sexist Apps, Biased Algorithms, and Other Threats of Toxic Tech",
            amazonLink:
                "https://www.amazon.com/dp/B06XJBGPT9/ref=dp-kindle-redirect?_encoding=UTF8&btkr=1",
            goodreadsLink:
                "https://www.goodreads.com/book/show/34068533-technically-wrong",
            audibleLink:
                "https://www.audible.com/pd/Science-Technology/Technically-Wrong-Audiobook/B075Y4VT2Q",
            authors: [
                {
                    id: "5",
                    firstName: "Sara",
                    lastName: "Wachter-Boettcher",
                    amazonLink:
                        "https://www.amazon.com/Sara-Wachter-Boettcher/e/B00AP5V5K4",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "9",
                    reason:
                        "I think this is a must-read for any designer working in tech, because it dives deeply into how our lived experiences and perspectives effect the products that we create (for better or for worse). To truly empathize with the users we design for, understanding ethics is imperative. This book provides many case studies to help build and strengthen that understanding.",
                    designer: {
                        id: "6",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/fukui.jpg",
                        firstName: "Kat",
                        lastName: "Fukui",
                        title: "Product designer at GitHub",
                        twitterUsername: "katfukui",
                        websiteLink: "http://katfukui.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                },
                {
                    id: "34",
                    reason:
                        "As designers, we're responsible for the impact of our work on the people who encounter it, whatever that impact may be, good or bad. Sara Wachter-Boettcher does an amazing job breaking down different ways that technology has harmed people with tons of examples, and helps readers understand what they can learn from those situations so they can do better.",
                    designer: {
                        id: "20",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/harllee.png",
                        firstName: "Jessica",
                        lastName: "Harllee",
                        title: "Staff product designer at Etsy",
                        twitterUsername: "harllee",
                        websiteLink: "http://www.jessicaharllee.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "10",
            title: "Deep Work",
            subtitle: "Rules for Focused Success in a Distracted World",
            amazonLink:
                "https://www.amazon.com/dp/B00X47ZVXM/ref=dp-kindle-redirect?_encoding=UTF8&btkr=1",
            goodreadsLink:
                "https://www.goodreads.com/book/show/25744928-deep-work",
            audibleLink:
                "https://www.audible.com/pd/Self-Development/Deep-Work-Audiobook/B0189PX1RQ",
            authors: [
                {
                    id: "12",
                    firstName: "Cal",
                    lastName: "Newport",
                    amazonLink:
                        "https://www.amazon.com/Cal-Newport/e/B001IGNR0U/ref=dp_byline_cont_ebooks_1",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "10",
                    reason:
                        "I'm a distracted person, but over time I've found ways to minimize external stimulation so that I can get in the zone and do my best work. Deep Work helps you understand why it is we're so distracted today, and how to find your own ways of finding focus.",
                    designer: {
                        id: "7",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/lovin.jpeg",
                        firstName: "Brian",
                        lastName: "Lovin",
                        title: "Co-founder of Spectrum",
                        twitterUsername: "brian_lovin",
                        websiteLink: "https://brianlovin.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "11",
            title: "The Hard Thing About Hard Things",
            subtitle: "Building a Business When There Are No Easy Answers",
            amazonLink:
                "https://www.amazon.com/dp/B00DQ845EA/ref=dp-kindle-redirect?_encoding=UTF8&btkr=1",
            goodreadsLink:
                "https://www.goodreads.com/book/show/18176747-the-hard-thing-about-hard-things",
            audibleLink:
                "https://www.audible.com/pd/Business/The-Hard-Thing-About-Hard-Things-Audiobook/B00I0AJC2Y",
            authors: [
                {
                    id: "13",
                    firstName: "Ben",
                    lastName: "Horowitz",
                    amazonLink:
                        "https://www.amazon.com/Ben-Horowitz/e/B00HALQ722/ref=dp_byline_cont_book_1",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "11",
                    reason:
                        "Startup stories are just fun to read, even if many of the lessons aren't directly applicable to what you're doing today. But reading fun things is worthwhile, and I think it's helpful for designers to get a closer perspective at what kinds of things end up truly mattering for startups.",
                    designer: {
                        id: "7",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/lovin.jpeg",
                        firstName: "Brian",
                        lastName: "Lovin",
                        title: "Co-founder of Spectrum",
                        twitterUsername: "brian_lovin",
                        websiteLink: "https://brianlovin.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                },
                {
                    id: "22",
                    reason:
                        "The Hard Thing About Hard Things is one of my favorites for being inspired by the hustle. For books, I recommend having a balance of fiction and non-fiction. A book to get you to dream and a book to get you to rethink about your world. In general, I recommend that every designer have a magazine subscription to either The New Yorker or another culture magazine like Kinfolk, this way they can keep themselves wrapped in different tastes and build empathy with current affairs and topics.",
                    designer: {
                        id: "10",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/grant.jpg",
                        firstName: "Chris",
                        lastName: "Grant",
                        title: "Product designer and creative",
                        twitterUsername: "OnlyChrisGrant",
                        websiteLink: "https://www.chrismgrant.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "12",
            title: "On Writing",
            subtitle: "A Memoir of the Craft",
            amazonLink:
                "https://www.amazon.com/dp/B000FC0SIM/ref=dp-kindle-redirect?_encoding=UTF8&btkr=1",
            goodreadsLink:
                "https://www.goodreads.com/book/show/10569.On_Writing",
            audibleLink:
                "https://www.audible.com/pd/Bios-Memoirs/On-Writing-Audiobook/B002V1A0WE",
            authors: [
                {
                    id: "14",
                    firstName: "Stephen",
                    lastName: "King",
                    amazonLink:
                        "https://www.amazon.com/Stephen-King/e/B000AQ0842/ref=dp_byline_cont_ebooks_1",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "12",
                    reason:
                        "If you want to talk about dedication to a craft, look no further. This is a short but worthwhile read with an incredible amount of directly-transferable advice to the design discipline.",
                    designer: {
                        id: "7",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/lovin.jpeg",
                        firstName: "Brian",
                        lastName: "Lovin",
                        title: "Co-founder of Spectrum",
                        twitterUsername: "brian_lovin",
                        websiteLink: "https://brianlovin.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "13",
            title: "Thinking, Fast and Slow",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/dp/B00555X8OA/ref=dp-kindle-redirect?_encoding=UTF8&btkr=1",
            goodreadsLink:
                "https://www.goodreads.com/book/show/11468377-thinking-fast-and-slow",
            audibleLink:
                "https://www.audible.com/pd/Science-Technology/Thinking-Fast-and-Slow-Audiobook/B005TKKCWC",
            authors: [
                {
                    id: "15",
                    firstName: "Daniel",
                    lastName: "Kahneman",
                    amazonLink:
                        "https://www.amazon.com/Daniel-Kahneman/e/B001ILFNQG",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "13",
                    reason:
                        "This is a long and dry book, but for anyone who is coming into design with no background in behavioral psychology, this is probably one of the best places to start.",
                    designer: {
                        id: "7",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/lovin.jpeg",
                        firstName: "Brian",
                        lastName: "Lovin",
                        title: "Co-founder of Spectrum",
                        twitterUsername: "brian_lovin",
                        websiteLink: "https://brianlovin.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "14",
            title: "The Social Animal",
            subtitle: "The Hidden Sources of Love, Character, and Achievement",
            amazonLink:
                "https://www.amazon.com/dp/B004IK8PFK/ref=dp-kindle-redirect?_encoding=UTF8&btkr=1",
            goodreadsLink:
                "https://www.goodreads.com/book/show/9628743-the-social-animal",
            audibleLink:
                "https://www.audible.com/pd/Science-Technology/The-Social-Animal-Audiobook/B004NEKPK4",
            authors: [
                {
                    id: "16",
                    firstName: "David",
                    lastName: "Brooks",
                    amazonLink:
                        "https://www.amazon.com/David-Brooks/e/B001ITTRLU/ref=dp_byline_cont_book_1",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "14",
                    reason:
                        "Books that dig into the *why* of the things that humans do are fascinating to me. Especially as a designer, thinking through the way people interpret the world around them and seek solutions to their problems is crucial to understand.",
                    designer: {
                        id: "7",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/lovin.jpeg",
                        firstName: "Brian",
                        lastName: "Lovin",
                        title: "Co-founder of Spectrum",
                        twitterUsername: "brian_lovin",
                        websiteLink: "https://brianlovin.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "15",
            title: "On Color",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/Color-David-Kastan/dp/0300171870",
            goodreadsLink:
                "https://www.goodreads.com/book/show/36288038-on-color",
            audibleLink:
                "https://www.audible.com/pd/Nonfiction/On-Color-Audiobook/B07CX7V9HB",
            authors: [
                {
                    id: "17",
                    firstName: "David",
                    lastName: "Kastan",
                    amazonLink:
                        "https://www.amazon.com/s/ref=dp_byline_sr_all_1?ie=UTF8&field-keywords=David+Scott+Kastan&search-alias=",
                    __typename: "AuthorType"
                },
                {
                    id: "18",
                    firstName: "Stephen",
                    lastName: "Farthing",
                    amazonLink:
                        "https://www.amazon.com/s/ref=dp_byline_sr_book_2?ie=UTF8&text=Stephen+Farthing&search-alias=books&field-author=Stephen+Farthing&sort=relevancerank",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "15",
                    reason:
                        "I love the book 'On Color' because it talks about how we perceive and the history behind colors.",
                    designer: {
                        id: "8",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/dong.jpg",
                        firstName: "Linda",
                        lastName: "Dong",
                        title: "Design manager at Lyft",
                        twitterUsername: "lindadong",
                        websiteLink: "https://lindadong.squarespace.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "16",
            title: "Creativity, Inc.",
            subtitle:
                "Overcoming the Unseen Forces That Stand in the Way of True Inspiration",
            amazonLink:
                "https://www.amazon.com/Creativity-Inc-Overcoming-Unseen-Inspiration/dp/0812993012",
            goodreadsLink:
                "https://www.goodreads.com/book/show/18077903-creativity-inc",
            audibleLink:
                "https://www.audible.com/pd/Business/Creativity-Inc-Audiobook/B00IPK3BWQ",
            authors: [
                {
                    id: "19",
                    firstName: "Ed",
                    lastName: "Catmull",
                    amazonLink:
                        "https://www.amazon.com/Ed-Catmull/e/B00FF0EDU8",
                    __typename: "AuthorType"
                },
                {
                    id: "20",
                    firstName: "Amy",
                    lastName: "Wallace",
                    amazonLink:
                        "https://www.amazon.com/Amy-Wallace/e/B00QJ3AU8Y",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "16",
                    reason:
                        "Creativity Inc. is all about how Pixar stayed creative while struggling with business needs, it’s a great reference for how to maintain the integrity of your ideas.",
                    designer: {
                        id: "8",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/dong.jpg",
                        firstName: "Linda",
                        lastName: "Dong",
                        title: "Design manager at Lyft",
                        twitterUsername: "lindadong",
                        websiteLink: "https://lindadong.squarespace.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "17",
            title: "House of Leaves",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/House-Leaves-Mark-Z-Danielewski/dp/0375703764",
            goodreadsLink:
                "https://www.goodreads.com/book/show/24800.House_of_Leaves",
            audibleLink: "",
            authors: [
                {
                    id: "21",
                    firstName: "Mark",
                    lastName: "Danielewski",
                    amazonLink:
                        "https://www.amazon.com/Mark-Z.-Danielewski/e/B000APTSK8",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "17",
                    reason:
                        "House of Leaves is an engrossing novel, an exploration in the art of the narrative and a typographical tour the force all rolled into one. Easily a must-read for a designer.",
                    designer: {
                        id: "9",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/dewith.png",
                        firstName: "Sebastiaan",
                        lastName: "de With",
                        title: "Co-founder and designer at Halide",
                        twitterUsername: "sdw",
                        websiteLink: "http://icondesigner.net/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "18",
            title: "Complexity",
            subtitle: "The Emerging Science at the Edge of Order and Chaos",
            amazonLink:
                "https://www.amazon.com/COMPLEXITY-EMERGING-SCIENCE-ORDER-CHAOS/dp/0671872346",
            goodreadsLink:
                "https://www.goodreads.com/book/show/337123.Complexity",
            audibleLink: "",
            authors: [
                {
                    id: "22",
                    firstName: "M. Mitchell",
                    lastName: "Waldrop",
                    amazonLink:
                        "https://www.amazon.com/M.-Mitchell-Waldrop/e/B000APDNB8",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "18",
                    reason:
                        "Much like design’s strange place between craft and art, the emerging science of complexity is an immensely nuanced an interesting field that has many parallels and applicable theories for us as designers.",
                    designer: {
                        id: "9",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/dewith.png",
                        firstName: "Sebastiaan",
                        lastName: "de With",
                        title: "Co-founder and designer at Halide",
                        twitterUsername: "sdw",
                        websiteLink: "http://icondesigner.net/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "19",
            title: "Designed for Use",
            subtitle: "Create Usable Interfaces for Applications and the Web",
            amazonLink:
                "https://www.amazon.com/Designed-Use-Create-Interfaces-Applications/dp/1934356751",
            goodreadsLink:
                "https://www.goodreads.com/book/show/19345694-designed-for-use",
            audibleLink: "",
            authors: [
                {
                    id: "23",
                    firstName: "Lukas",
                    lastName: "Mathis",
                    amazonLink:
                        "https://www.amazon.com/Lukas-Mathis/e/B0051VEQ1C",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "19",
                    reason:
                        "A great book by one of my favorite design thinkers.",
                    designer: {
                        id: "9",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/dewith.png",
                        firstName: "Sebastiaan",
                        lastName: "de With",
                        title: "Co-founder and designer at Halide",
                        twitterUsername: "sdw",
                        websiteLink: "http://icondesigner.net/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "20",
            title: "The Man Who Mistook His Wife for a Hat",
            subtitle: "And Other Clinical Tales",
            amazonLink:
                "https://www.amazon.com/Man-Who-Mistook-His-Wife/dp/0684853949",
            goodreadsLink:
                "https://www.goodreads.com/book/show/63697.The_Man_Who_Mistook_His_Wife_for_a_Hat_and_Other_Clinical_Tales",
            audibleLink:
                "https://www.audible.com/pd/Science-Technology/The-Man-Who-Mistook-His-Wife-for-a-Hat-and-Other-Clinical-Tales-Audiobook/B0051VJH84",
            authors: [
                {
                    id: "24",
                    firstName: "Oliver",
                    lastName: "Sacks",
                    amazonLink:
                        "https://www.amazon.com/Oliver-Sacks/e/B000APZZY6",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "20",
                    reason:
                        "We work, as designers, in creating things for humans to enjoy. In the end, we engage brains — and the way Oliver Sacks explores brains, their quirks, and specific ways they can fail us or leave us in different states, is eye-opening and is sure to give you perspective on your own existence, life and work. All his other books are also great.",
                    designer: {
                        id: "9",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/dewith.png",
                        firstName: "Sebastiaan",
                        lastName: "de With",
                        title: "Co-founder and designer at Halide",
                        twitterUsername: "sdw",
                        websiteLink: "http://icondesigner.net/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "21",
            title: "Future Noir",
            subtitle: "The Making of Blade Runner",
            amazonLink:
                "https://www.amazon.com/Future-Noir-Revised-Updated-Making-ebook/dp/B076P7CYMX",
            goodreadsLink:
                "https://www.goodreads.com/book/show/80234.Future_Noir",
            audibleLink: "",
            authors: [
                {
                    id: "25",
                    firstName: "Paul",
                    lastName: "Sammon",
                    amazonLink:
                        "https://www.amazon.com/Paul-M.-Sammon/e/B000APLGWQ",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "21",
                    reason:
                        "A great look into how one of the greatest, most creative films of all time was conceived, filled out, and made.",
                    designer: {
                        id: "9",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/dewith.png",
                        firstName: "Sebastiaan",
                        lastName: "de With",
                        title: "Co-founder and designer at Halide",
                        twitterUsername: "sdw",
                        websiteLink: "http://icondesigner.net/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "22",
            title: "Play It as It Lays",
            subtitle: "A Novel",
            amazonLink:
                "https://www.amazon.com/Play-as-Lays-Joan-Didion-ebook/dp/B072HMBLSN",
            goodreadsLink:
                "https://www.goodreads.com/book/show/428.Play_It_as_It_Lays",
            audibleLink: "",
            authors: [
                {
                    id: "26",
                    firstName: "Joan",
                    lastName: "Didion",
                    amazonLink:
                        "https://www.amazon.com/Joan-Didion/e/B000AQ4ZD2",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "23",
                    reason:
                        "Didion’s Play It As It Lays helps me think about details and how craft can extend into writing.",
                    designer: {
                        id: "10",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/grant.jpg",
                        firstName: "Chris",
                        lastName: "Grant",
                        title: "Product designer and creative",
                        twitterUsername: "OnlyChrisGrant",
                        websiteLink: "https://www.chrismgrant.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "23",
            title: "The Innovator's Dilemma",
            subtitle: "When New Technologies Cause Great Firms to Fail",
            amazonLink:
                "https://www.amazon.com/Innovators-Dilemma-Technologies-Management-Innovation/dp/1633691780",
            goodreadsLink:
                "https://www.goodreads.com/book/show/2615.The_Innovator_s_Dilemma",
            audibleLink:
                "https://www.audible.com/pd/Business/The-Innovators-Dilemma-Audiobook/B06Y4VPJSJ",
            authors: [
                {
                    id: "27",
                    firstName: "Clayton",
                    lastName: "Christensen",
                    amazonLink:
                        "https://www.amazon.com/Clayton-M.-Christensen/e/B000APPD3Y",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "24",
                    reason:
                        "The most important book I keep coming back to is “The Innovator’s Dilemma” by Clayton Christensen. The concepts and explanations of Disruptive innovation I apply almost everyday when looking at the products I work on. Related to that “Competing Against Luck” is another book I love because Jobs To Be Done is something I have used for about a decade. Innovation and JTBD are two sides of a coin.",
                    designer: {
                        id: "11",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/lax.jpg",
                        firstName: "Jon",
                        lastName: "Lax",
                        title: "Director of Product Design at Facebook",
                        twitterUsername: "jlax",
                        websiteLink: "https://www.facebook.com/jon.lax.75",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "24",
            title: "A Pattern Language",
            subtitle: "Towns, Buildings, Construction",
            amazonLink:
                "https://www.amazon.com/Pattern-Language-Buildings-Construction-Environmental/dp/0195019199",
            goodreadsLink:
                "https://www.goodreads.com/book/show/79766.A_Pattern_Language",
            audibleLink: "",
            authors: [
                {
                    id: "28",
                    firstName: "Christopher",
                    lastName: "Alexander",
                    amazonLink:
                        "https://www.amazon.com/Christopher-Alexander/e/B000AQ4JVU",
                    __typename: "AuthorType"
                },
                {
                    id: "29",
                    firstName: "Sara",
                    lastName: "Ishikawa",
                    amazonLink:
                        "https://www.amazon.com/Sara-Ishikawa/e/B000AQ4K1Y",
                    __typename: "AuthorType"
                },
                {
                    id: "30",
                    firstName: "Murray",
                    lastName: "Silverstein",
                    amazonLink:
                        "https://www.amazon.com/Murray-Silverstein/e/B000AQ6PC6",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "25",
                    reason:
                        "'A Pattern language' is a fascinating study of the design of physical spaces. It isn’t really a book you read cover to cover but it is one that I consult, especially now that I am working in AR/VR which is volumetric and dealing with space.",
                    designer: {
                        id: "11",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/lax.jpg",
                        firstName: "Jon",
                        lastName: "Lax",
                        title: "Director of Product Design at Facebook",
                        twitterUsername: "jlax",
                        websiteLink: "https://www.facebook.com/jon.lax.75",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "25",
            title: "Accessibility for Everyone",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/Accessibility-Everyone-Laura-Kalbag/dp/1937557618",
            goodreadsLink:
                "https://www.goodreads.com/book/show/36312164-accessibility-for-everyone",
            audibleLink: "",
            authors: [
                {
                    id: "32",
                    firstName: "Laura",
                    lastName: "Kalbag",
                    amazonLink:
                        "https://www.amazon.com/s/ref=dp_byline_sr_book_1?ie=UTF8&text=Laura+Kalbag&search-alias=books&field-author=Laura+Kalbag&sort=relevancerank",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "26",
                    reason:
                        "It is so important for the design community to have a base understanding for how to make the things we build inclusive for everyone. Not only do we need to consider color contrast or keyboard accessibility but also clear copywriting or environmental factors. Laura covers all of this but takes it a step further and discusses how best integrate accessibility into your workflow as an individual and as a team. Accessibility for Everyone is one of my favorite books to reference and everyone should read it.",
                    designer: {
                        id: "12",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/gutowski.jpg",
                        firstName: "Kevin",
                        lastName: "Gutowski",
                        title: "Designer at Gradescope",
                        twitterUsername: "kevgski",
                        websiteLink: "http://kevingutowski.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "26",
            title: "The Innovators",
            subtitle:
                "How a Group of Hackers, Geniuses, and Geeks Created the Digital Revolution",
            amazonLink:
                "https://www.amazon.com/Innovators-Hackers-Geniuses-Created-Revolution/dp/1476708703",
            goodreadsLink:
                "https://www.goodreads.com/book/show/21856367-the-innovators",
            audibleLink:
                "https://www.audible.com/pd/Science-Technology/The-Innovators-Audiobook/B00M9KA2ZM",
            authors: [
                {
                    id: "33",
                    firstName: "Walter",
                    lastName: "Isaacson",
                    amazonLink:
                        "https://www.amazon.com/Walter-Isaacson/e/B000APFLB8",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "27",
                    reason:
                        "My favorite book I have read lately was the The Innovators by Walter Isaacson. It puts into perspective how on one level the partnership between engineering and vision drives us forward, and the culture we in tech live in is framed by creativity, innovation and experimentation.",
                    designer: {
                        id: "13",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/levine.jpeg",
                        firstName: "Jason",
                        lastName: "Levine",
                        title: "User Experience Director at Indeed.com",
                        twitterUsername: "perfectpixels",
                        websiteLink: "http://www.perfectpixels.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "27",
            title: "A Place of My Own",
            subtitle: "The Architecture of Daydreams",
            amazonLink:
                "https://www.amazon.com/Place-My-Own-Architecture-Daydreams/dp/0143114743",
            goodreadsLink:
                "https://www.goodreads.com/book/show/13838.A_Place_of_My_Own",
            audibleLink:
                "https://www.audible.com/pd/Bios-Memoirs/A-Place-of-My-Own-Audiobook/B003YM8C38",
            authors: [
                {
                    id: "34",
                    firstName: "Michael",
                    lastName: "Pollan",
                    amazonLink:
                        "https://www.amazon.com/Michael-Pollan/e/B000AQ74HQ",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "28",
                    reason:
                        "I am a big fan of Michael Pollan, and this early book brings his clear writing to his experience of designing and building a writing studio for himself. It is a book about the design process that is expansive and narrow, philosophical and practical and a great narrative about the pleasure and pain of building a structure without the splinters.",
                    designer: {
                        id: "14",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/felton.jpg",
                        firstName: "Nicholas",
                        lastName: "Felton",
                        title: "Information designer",
                        twitterUsername: "feltron",
                        websiteLink: "http://feltron.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "28",
            title: "Tools for Conviviality",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/Tools-Conviviality-Ivan-Illich/dp/1842300113",
            goodreadsLink:
                "https://www.goodreads.com/book/show/253076.Tools_for_Conviviality",
            audibleLink: "",
            authors: [
                {
                    id: "35",
                    firstName: "Ivan",
                    lastName: "Illich",
                    amazonLink:
                        "https://www.amazon.com/Ivan-Illich/e/B000APUQZY",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "29",
                    reason:
                        "Written in the 70s, Illich, a philosopher, warns us of the watershed moment that arises when a community's relationship to its tools is fundamentally reshaped as knowledge of tool making evolves into the domain of a small class of experts. Illch offers up a solution (alternative means of production), but the critique is the most important part of the book. I think anyone who is making things for others should read this book and then read it again. Designers, more than ever, need a stronger consciousness about things we make.",
                    designer: {
                        id: "15",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/tillman.jpg",
                        firstName: "Kristy",
                        lastName: "Tillman",
                        title: "Leading Global Workplace Design at Slack",
                        twitterUsername: "KristyT",
                        websiteLink: "http://todayyesterdaytomorrow.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "29",
            title: "Interaction of Color",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/Interaction-Color-Anniversary-Josef-Albers/dp/0300179359",
            goodreadsLink:
                "https://www.goodreads.com/book/show/111113.Interaction_of_Color",
            audibleLink: "",
            authors: [
                {
                    id: "36",
                    firstName: "Josef",
                    lastName: "Albers",
                    amazonLink:
                        "https://www.amazon.com/Josef-Albers/e/B004N21VCW",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "30",
                    reason:
                        "Thinking about color entirely in relative terms - as opposed to absolute values devoid of external context - is one of those things that many people just don't think about until someone points it out to them. Josef Albers does a great job of sharing his research into all the ways that color and space affect each other. Once you've seen color through Albers' experiments, you can't unsee it.",
                    designer: {
                        id: "16",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/jackson.jpg",
                        firstName: "Bryn",
                        lastName: "Jackson",
                        title: "Co-founder of Spectrum",
                        twitterUsername: "defaultbryn",
                        websiteLink: "https://bryn.io/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "30",
            title: "Autobiography of Red",
            subtitle: "",
            amazonLink:
                "https://www.amazon.com/Autobiography-Red-Anne-Carson/dp/037570129X",
            goodreadsLink:
                "https://www.goodreads.com/book/show/61049.Autobiography_of_Red",
            audibleLink:
                "https://www.audible.com/pd/Fiction/Autobiography-of-Red-Audiobook/B01FQJFXFQ",
            authors: [
                {
                    id: "37",
                    firstName: "Anne",
                    lastName: "Carson",
                    amazonLink:
                        "https://www.amazon.com/Anne-Carson/e/B001IXTUEU",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "31",
                    reason:
                        "It’s like a photograph in words. Many have lost the stamina to read long-form fiction these days. The same muscles needed for broad imagination and empathy have been allowed to atrophy and it’s a shame. The ability to visualize vividly and consider other perspectives in first person is critical to being a good maker. Carson skillfully marries the mundane with the surreal in this lush and challenging short novel, which reads like poetry.",
                    designer: {
                        id: "17",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/baik.jpg",
                        firstName: "Coleen",
                        lastName: "Baik",
                        title: "Indie product designer, illustrator, advisor",
                        twitterUsername: "colbay",
                        websiteLink: "http://coleenbaik.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "31",
            title: "Start with Why",
            subtitle: "How Great Leaders Inspire Everyone to Take Action",
            amazonLink:
                "https://www.amazon.com/Start-Why-Leaders-Inspire-Everyone-ebook/dp/B002Q6XUE4",
            goodreadsLink:
                "https://www.goodreads.com/book/show/7108725-start-with-why",
            audibleLink:
                "https://www.audible.com/pd/Business/Start-with-Why-Audiobook/B074VDVHZ5",
            authors: [
                {
                    id: "38",
                    firstName: "Simon",
                    lastName: "Sinek",
                    amazonLink:
                        "https://www.amazon.com/Simon-Sinek/e/B002CB2SDC",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "32",
                    reason:
                        "Forget about what or how, what about why? What I loved about this book is that it challenges you to go to the essence of what you’re doing. What is the motive behind each decision or action? What is it helping you succeed at? Start With Why forces you to think bigger and approach problems and challenges by considering the why instead of jumping straight to the what and how. Why works as a long-term anchor and helps us evolve the what and how over time.",
                    designer: {
                        id: "18",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/schoonhoven.jpg",
                        firstName: "Femke",
                        lastName: "van Schoonhoven",
                        title: "Product designer at Uber",
                        twitterUsername: "femkesvs",
                        websiteLink: "https://www.femke.co.nz/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "32",
            title: "Quiet",
            subtitle:
                "The Power of Introverts in a World That Can't Stop Talking",
            amazonLink:
                "https://www.amazon.com/Quiet-Power-Introverts-World-Talking/dp/0307352153",
            goodreadsLink: "https://www.goodreads.com/book/show/8520610-quiet",
            audibleLink:
                "https://www.audible.com/pd/Science-Technology/Quiet-Audiobook/B006TIKUN4",
            authors: [
                {
                    id: "39",
                    firstName: "Susan",
                    lastName: "Cain",
                    amazonLink:
                        "https://www.amazon.com/Susan-Cain/e/B004XVMVYK",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "33",
                    reason:
                        "It really helped me understand that leadership and working styles take many different forms and there isn't one 'right' way to be successful. So instead of trying and failing to be something, there's inherent value in being myself. The book talks about it in terms of introvert/extrovert but I think it totally applies beyond that.",
                    designer: {
                        id: "19",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/pinkser.jpg",
                        firstName: "Amanda",
                        lastName: "Pinsker",
                        title: "Product designer at GitHub",
                        twitterUsername: "ampinsk",
                        websiteLink: "https://amandapinsker.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "33",
            title: "Radical Candor",
            subtitle: "Be a Kick-Ass Boss Without Losing Your Humanity",
            amazonLink:
                "https://www.amazon.com/Radical-Candor-Kick-Ass-Without-Humanity/dp/1250103509",
            goodreadsLink:
                "https://www.goodreads.com/book/show/29939161-radical-candor",
            audibleLink:
                "https://www.audible.com/pd/Business/Radical-Candor-Audiobook/B01MZ6RMS4",
            authors: [
                {
                    id: "40",
                    firstName: "Kim",
                    lastName: "Scott",
                    amazonLink: "https://www.amazon.com/default/e/B00J7H93HI",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "35",
                    reason:
                        "I'm not a manager, but I love reading books on management and leadership to help me be a better teammate. In this book, Kim Scott describes the concept of radical candor (care personally and challenge directly) as it relates to giving feedback, motivating people, and making things happen. Reading this has already had a huge impact on the way that I interact with the people around me.",
                    designer: {
                        id: "20",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/harllee.png",
                        firstName: "Jessica",
                        lastName: "Harllee",
                        title: "Staff product designer at Etsy",
                        twitterUsername: "harllee",
                        websiteLink: "http://www.jessicaharllee.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "34",
            title: "Annapurna",
            subtitle: "A Woman's Place",
            amazonLink:
                "https://www.amazon.com/Annapurna-Womans-Place-Arlene-Blum/dp/1619026031",
            goodreadsLink:
                "https://www.goodreads.com/book/show/306659.Annapurna",
            audibleLink: "",
            authors: [
                {
                    id: "41",
                    firstName: "Arlene",
                    lastName: "Blum",
                    amazonLink: "https://www.amazon.com/default/e/B000AQ4118",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "36",
                    reason:
                        "The one book I most consistently gift to people in design leadership is Annapurna: A Woman's Place by Arlene Blum.\nThis book speaks to me for so many reasons. Arlene organized the first successful American ascent of Annapurna, at the time regarded as the most difficult mountain to climb in the world. Notably, this was an all female ascent. Arlene had tried to join other teams attempting the climb and they all told her a woman could only come along as a cook, and not a climber, even though she was far more experienced than most of the men's teams attempting the mountain. She organized a group of women, and they raised money for the climb by selling shirts with the slogan 'A Woman's Place is On Top.'\nI believe this group of women were successful specifically because of their unique collaboration skills. Arlene had to learn how to make everyone's feedback feel heard while still being ultimately accountable for the decision making and keeping things moving in a positive direction. She had to do this in life or death circumstances, and with exhausted people whose emotions were running high. She had to be flexible and decisive while weather conditions and people's health were in flux. Even after their climb the team faced a lot of criticism from men, some of whom even wrote in to climbing journals to denigrate the climb, signing the letters as their girlfriends. I commemorated both the anniversary of this climb, and my own completion of mountaineering school with a 'A Woman's Place is On Top' poster homage that I keep close to my workspace to remind me of Arlene's struggles.",
                    designer: {
                        id: "21",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/dean.jpg",
                        firstName: "Beth",
                        lastName: "Dean",
                        title: "Product Design Manager at Facebook",
                        twitterUsername: "bethdean",
                        websiteLink: "http://www.thebethdean.com/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        },
        {
            id: "35",
            title: "On Writing Well",
            subtitle: "The Classic Guide to Writing Nonfiction",
            amazonLink:
                "https://www.amazon.com/Writing-Well-Classic-Guide-Nonfiction/dp/0060891548",
            goodreadsLink:
                "https://www.goodreads.com/book/show/53343.On_Writing_Well",
            audibleLink:
                "https://www.audible.com/pd/On-Writing-Well-Audio-Collection-Audiobook/B002V8KQLC",
            authors: [
                {
                    id: "42",
                    firstName: "William",
                    lastName: "Zinsser",
                    amazonLink:
                        "https://www.amazon.com/William-Zinsser/e/B000AQ1LN4",
                    __typename: "AuthorType"
                }
            ],
            recommendations: [
                {
                    id: "37",
                    reason:
                        "There has been no single skill that has helped my design career more than writing. This book is a true pleasure to read and has helped improve my ability to communicate ideas.",
                    designer: {
                        id: "22",
                        avatar:
                            "https://s3-us-west-1.amazonaws.com/readinglist.design/morse.jpg",
                        firstName: "Adam",
                        lastName: "Morse",
                        title: "Designer in London",
                        twitterUsername: "mrmrs_",
                        websiteLink: "http://mrmrs.cc/",
                        __typename: "DesignerType"
                    },
                    __typename: "RecommendationType"
                }
            ],
            __typename: "BookType"
        }
    ]
};

const books = sortBooks(data.books);

class BookListPage extends Component {
    render() {
        return (
            <Flex
                flexDirection="column"
                flex={1}
                bg="bookBG"
                style={{ minHeight: 0 }}
            >
                <AnimationController books={books} />
            </Flex>
        );
    }
}

export default BookListPage;



// WEBPACK FOOTER //
// ./src/pages/BookListPage/index.js